export const CHALLENGE_PAGE_EXPERIMENT = {
  name: 'challenge_page_redesign_2026_08',
  featureFlag: 'challenge-page-redesign-2026-08',
  posthogExperimentId: 445170,
  variants: {
    control: 'Current challenge page',
    test: 'Refined challenge page',
  },
  primaryMetric: 'Confirmed challenge registrations per exposed user',
  secondaryMetrics: ['Challenge form submissions per exposed user'],
} as const;
